import { Copy, Eye, X } from "react-feather";
import styles from "./tenantcontactinfo.module.css";
import { Dialog, DialogContent, Tooltip, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CopyToClipboard from "react-copy-to-clipboard";
import moment from "moment";

const TenantContactInfo = ({ tenantData, setLoading, activeTenant, expanded, handleChange }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [docUrl, setDocUrl] = useState("");
  const [openDocModal, setOpenDocModal] = useState(false);
  const [emailCopied, setEmailCopied] = useState(false);

  const viewDocumnet2 = async (id) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/get-tenant-document/" + id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setOpenDocModal(true);
      setDocUrl(response.data.data?.file_url);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const viewCreditReport = async (tenantInfoId) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/get-report-link/" + tenantInfoId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      window.open(response?.data?.url);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
      <div className={`${styles.FormAccoHead}`}>
        <p className={`${styles.FormAccoHeadTitlePro}`}>Contact Info</p>
      </div>
    </AccordionSummary>
    <AccordionDetails>
      <div className={`${styles.SMProCardDe}`}>
        <ul>
          <li>
            <span className={`${styles.SMProDETag}`}>Email:</span>
            <CopyToClipboard text={tenantData?.all_tenants[activeTenant]?.email} onCopy={() => setEmailCopied(true)}>
              <Tooltip title={emailCopied ? "Copied" : "Copy"}>
                <a className={`${styles.SMProDE}`} style={{ cursor: "pointer" }}>
                  <Copy />
                  {tenantData?.all_tenants.length > 0 && tenantData?.all_tenants[activeTenant] && tenantData?.all_tenants[activeTenant]?.email}
                </a>
              </Tooltip>
            </CopyToClipboard>
          </li>
          <li>
            <span className={`${styles.SMProDETag}`}>Phone:</span>
            <span className={`${styles.SMProDE}`}>{tenantData?.all_tenants.length > 0 && tenantData?.all_tenants[activeTenant] && tenantData?.all_tenants[activeTenant]?.phone}</span>
          </li>
          <li>
            <span className={`${styles.SMProDETag}`}>Property:</span>
            <Link to={"/properties/details/" + tenantData?.property_id} className={`${styles.SMProDE}`}>{tenantData?.property?.name}</Link>
          </li>
          <li>
            <span className={`${styles.SMProDETag}`}>Apartment:</span>
            <span className={`${styles.SMProDE}`}>{tenantData?.apartment?.apt_no}</span>
          </li>
          {/*<li>
            <span className={`${styles.SMProDETag}`}>Lease Term:</span>
            <Link to={"/leases/details/" + tenantData?.id} className={`${styles.SMProDE}`}>{moment(tenantData?.leases?.start_date).format("MM/DD/YYYY")}{" "}-{" "}{moment(tenantData?.leases?.end_date).format("MM/DD/YYYY")}</Link>
          </li>
          tenantData?.all_tenants[activeTenant]?.document_type !== "" && (<li>
            <span className={`${styles.SMProDETag}`}>Verification:</span>
            <Link className={`${styles.SMProDE}`} onClick={(e) => { e.preventDefault(); viewDocumnet2(tenantData?.all_tenants[activeTenant]?.id); }}>
              <Eye />
              {tenantData?.all_tenants[activeTenant]?.document_type === "passport" && "Passport"}
              {tenantData?.all_tenants[activeTenant]?.document_type === "id_card" && "Id Card"}
              {tenantData?.all_tenants[activeTenant]?.document_type === "driving_license" && "Driver License"}
            </Link>
          </li>)}
          {tenantData?.all_tenants[activeTenant]?.is_credit_score_verify === 1 && (<li>
            <span className={`${styles.SMProDETag}`}>Credit Score:</span>
            <Link className={`${styles.SMProDE}`} onClick={(e) => { e.preventDefault(); viewCreditReport(tenantData?.all_tenants[activeTenant]?.id); }}>
              <Eye />
              {tenantData?.all_tenants[activeTenant]?.credit_score}
            </Link>
            <img src="/static/img/verified.svg" className={`${styles.Varified}`} alt="" style={{ width: '16px', marginLeft: '12px' }} />
          </li>)*/}
        </ul>
      </div>

      <Dialog
        onClose={(e) => { setOpenDocModal(false); setDocUrl(""); }}
        aria-labelledby="customized-dialog-title"
        open={openDocModal}
        className="NewPopUp NewPopUpForLease"
      >
        <button onClick={(e) => { setOpenDocModal(false); setDocUrl(""); }} className={`${styles.IDImageCloseBU}`}><X /></button>
        <DialogContent>
          <div className={`${styles.IDImageSec}`}>
            <img src={docUrl} className={`${styles.IDImage}`} alt="" />
          </div>
        </DialogContent>
      </Dialog>
    </AccordionDetails>
  </Accordion>);
};

export default TenantContactInfo;